"use strict";
var cloneDeep = require("lodash/cloneDeep");
var ALLOWED_PERMISSION_TO_EDIT_STUDENTS = "create_student_groups";
var EDIT_STUDENTS_URL = "/studentsmain/groups/groups.php?viewGroup=1&gid=";
var STUDENTS_PER_PAGE = 10;
var GROUP_INIT_DATA = "group";
var INSTRUCTORS_INIT_DATA = "instructors";
var STUDY_PROGRAMS_INIT_DATA = "studyPrograms";
var Editor;
(function (Editor) {
    Editor[Editor["instructors"] = 0] = "instructors";
    Editor[Editor["study_programs"] = 1] = "study_programs";
})(Editor || (Editor = {}));
var GroupDetailController = (function () {
    /* @ngInject */
    function GroupDetailController($route, userService, $window, SUCCEED, groupsService, messagingService, userSessionService, typeaheadProviderService) {
        var _this = this;
        this.$route = $route;
        this.$window = $window;
        this.groupsService = groupsService;
        this.messagingService = messagingService;
        this.userSessionService = userSessionService;
        this.typeaheadProviderService = typeaheadProviderService;
        this.currentPage = 1;
        this.pendingInstructorsUpdate = false;
        this.pendingStudyProgramsUpdate = false;
        this.showError = false;
        this.tooltipIsVisible = false;
        this.instructorTypeaheadPaths = [
            "name.firstName",
            "name.lastName",
            "name.displayName"
        ];
        this.programTypeaheadPaths = [
            "courseSlug",
            "courseTitle"
        ];
        this.closeEdit = function () {
            _this.editor = void 0;
        };
        this.handleAdd = function (tag, type) {
            _this.tagType = _this.typeaheadProviderService.setTagType(type, _this.editedGroup);
            _this.tagType.push(tag);
        };
        this.handleRemove = function (tag, type) {
            _this.tagType = _this.typeaheadProviderService.setTagType(type, _this.editedGroup);
            _this.tagType.splice(_this.tagType.indexOf(tag), 1);
        };
        this.typeaheadProvider = function (input, typeaheadSource, tags, typeaheadPaths) {
            return _this.typeaheadProviderService.typeaheadProvider(input, typeaheadSource, tags, typeaheadPaths);
        };
        this.sortByStudentName = function (a, b) {
            var order = _this.isAscendingSort ? 1 : -1;
            var lastNameSort = order * (a.lastName > b.lastName ? 1 : (b.lastName > a.lastName ? -1 : 0));
            if (!lastNameSort) {
                return order * (a.firstName > b.firstName ? 1 : (b.firstName > a.firstName ? -1 : 0));
            }
            return lastNameSort;
        };
        this.sortByClassYear = function (a, b) {
            var order = _this.isAscendingSort ? 1 : -1;
            return order * (a.classYear > b.classYear ? 1 : (b.classYear > a.classYear ? -1 : 0));
        };
        this.loadUser = function (currentUser) {
            _this.currentUser = currentUser;
            _this.updateCrumbs();
        };
        this.handleGroupInstructorsUpdate = function (status) {
            if (!_this.editedGroup || !status || status >= 400) {
                _this.showError = true;
            }
            else {
                _this.group.instructors = _this.editedGroup.instructors;
                _this.lastEdit = Editor.instructors;
            }
            _this.editedGroup = undefined;
            _this.pendingUpdate = void 0;
        };
        this.handleGroupStudyProgramsUpdate = function (status) {
            if (!_this.editedGroup || !status || status >= 400) {
                _this.showError = true;
            }
            else {
                _this.group.productGroups.TESTPREP.studyPrograms = _this.editedGroup
                    .productGroups.TESTPREP.studyPrograms;
                _this.lastEdit = Editor.study_programs;
            }
            _this.editedGroup = undefined;
            _this.pendingUpdate = void 0;
        };
        this.editStudentsHost = SUCCEED;
        this.isAscendingSort = false;
        this.sortIcon = "ns-icon--sort";
        this.groupId = this.$route.current.params.groupId;
        this.tenantId = this.$route.current.params.tenantId;
        userService.get().then(this.loadUser);
        this.messages = messagingService("students");
    }
    GroupDetailController.prototype.$onInit = function () {
        this.group = this.$route.current.locals[GROUP_INIT_DATA];
        this.instructors = this.$route.current.locals[INSTRUCTORS_INIT_DATA];
        if (this.instructors) {
            this.instructors.sort(GroupDetailController.sortInstructors);
        }
        this.studyPrograms = this.$route.current.locals[STUDY_PROGRAMS_INIT_DATA];
        if (this.studyPrograms) {
            this.studyPrograms.sort(GroupDetailController.sortStudyPrograms);
        }
        if (this.hasStudentsToShow()) {
            this.sortStudents("name");
            this.refreshDisplayedStudents();
        }
        this.updateCrumbs();
    };
    GroupDetailController.prototype.hideError = function () { this.showError = false; };
    GroupDetailController.prototype.getDisplayInfo = function () {
        var count = this.currentPage * STUDENTS_PER_PAGE;
        var start = count - (STUDENTS_PER_PAGE - 1);
        var end = (count > this.getStudentCount()) ? this.getStudentCount() : count;
        return start + "-" + end;
    };
    GroupDetailController.prototype.setEditor = function (editor) {
        this.lastEdit = void 0;
        this.editor = Editor[editor];
        this.editedGroup = cloneDeep(this.group);
    };
    GroupDetailController.prototype.isEditor = function (editor) { return this.editor === Editor[editor]; };
    GroupDetailController.prototype.wasLastEdited = function (editor) { return this.lastEdit === Editor[editor]; };
    GroupDetailController.prototype.isPendingUpdate = function (editor) { return this.pendingUpdate === Editor[editor]; };
    GroupDetailController.prototype.saveInstructorsEdit = function () {
        var closeEdit = true;
        if (!this.editedGroup || !this.isEditor(Editor[Editor.instructors])) {
            this.showError = true;
        }
        else {
            if (this.editedGroup.instructors.length > 0) {
                this.pendingUpdate = Editor.instructors;
                this.groupsService.updateInstructors(this.tenantId, this.editedGroup)
                    .then(this.handleGroupInstructorsUpdate);
            }
            else {
                closeEdit = false;
            }
        }
        if (closeEdit) {
            this.closeEdit();
        }
    };
    GroupDetailController.prototype.saveStudyProgramsEdit = function () {
        var closeEdit = true;
        if (!this.editedGroup || !this.isEditor(Editor[Editor.study_programs])) {
            this.showError = true;
        }
        else {
            if (this.editedGroup.productGroups.TESTPREP.studyPrograms.length > 0) {
                this.pendingUpdate = Editor.study_programs;
                this.groupsService.updateStudyPrograms(this.tenantId, this.editedGroup)
                    .then(this.handleGroupStudyProgramsUpdate);
            }
            else {
                closeEdit = false;
            }
        }
        if (closeEdit) {
            this.closeEdit();
        }
    };
    GroupDetailController.prototype.showPaginator = function () { return this.pages && this.pages.length > 1; };
    GroupDetailController.prototype.refreshDisplayedStudents = function () {
        var _this = this;
        this.pages = [[]];
        this.group.students.forEach(function (student) {
            var lastPage = _this.pages[_this.pages.length - 1];
            if (lastPage.length >= STUDENTS_PER_PAGE) {
                _this.pages.push([]);
                lastPage = _this.pages[_this.pages.length - 1];
            }
            lastPage.push(student);
        });
        this.currentPage = Math.min(this.pages.length, this.currentPage);
    };
    GroupDetailController.prototype.getStudentCount = function () {
        return this.group.students && this.group.students.length;
    };
    GroupDetailController.prototype.getPageOfStudents = function () {
        return this.pages && this.pages[this.currentPage - 1];
    };
    GroupDetailController.prototype.hasStudentsToShow = function () {
        return this.group && this.group.students && this.group.students.length > 0;
    };
    GroupDetailController.prototype.sortStudents = function (sortField) {
        this.isAscendingSort = !this.isAscendingSort;
        if (sortField !== this.sortField) {
            this.isAscendingSort = true;
        }
        this.sortField = sortField;
        this.sortIcon = "ns-icon--sort-" + (this.isAscendingSort ? "up" : "down");
        if (sortField === "name") {
            this.group.students.sort(this.sortByStudentName);
        }
        else {
            this.group.students.sort(this.sortByClassYear);
        }
        this.refreshDisplayedStudents();
    };
    GroupDetailController.prototype.getSortIcon = function (sortField) {
        if (this.sortField === sortField) {
            return this.sortIcon;
        }
        return "ns-icon--sort";
    };
    GroupDetailController.prototype.getMessage = function () {
        var key = "noStudents";
        return this.messages[key];
    };
    GroupDetailController.prototype.showEditStudentsButton = function () {
        if (this.currentUser && this.currentUser.permissions && this.currentUser.permissions.length > 0) {
            return this.currentUser.hasPermission(ALLOWED_PERMISSION_TO_EDIT_STUDENTS);
        }
    };
    GroupDetailController.prototype.showTooltip = function () { this.tooltipIsVisible = true; };
    GroupDetailController.prototype.hideTooltip = function () { this.tooltipIsVisible = false; };
    GroupDetailController.prototype.jumpToEditStudents = function () {
        this.$window.location.href = this.editStudentsHost + EDIT_STUDENTS_URL + this.group.groupId;
    };
    GroupDetailController.prototype.getGrade = function (student) {
        if (!student.grade) {
            return "";
        }
        if (student.grade > 12) {
            return "(ALUMNI)";
        }
        return "(Grade " + student.grade + ")";
    };
    GroupDetailController.prototype.updateCrumbs = function () {
        if (this.userSessionService.isDistrictMode()) {
            this.crumbs = [
                {
                    name: "Naviance Test Prep: District",
                    url: "" + this.userSessionService.getDistrictTenantId()
                },
                {
                    name: "" + this.userSessionService.getCurrentSchool().name,
                    url: "" + this.userSessionService.getDistrictTenantId()
                },
                { name: this.group.groupName }
            ];
        }
        else {
            this.crumbs = [
                {
                    name: "Naviance Test Prep",
                    url: "" + this.tenantId
                },
                { name: this.group.groupName }
            ];
        }
    };
    GroupDetailController.prototype.hasNoInstructors = function () {
        return !this.editedGroup.instructors.length;
    };
    GroupDetailController.prototype.hasNoStudyPrograms = function () {
        return !this.editedGroup.productGroups.TESTPREP.studyPrograms.length;
    };
    GroupDetailController.sortInstructors = function (instructorA, instructorB) {
        return instructorA.name.displayName.localeCompare(instructorB.name.displayName);
    };
    GroupDetailController.sortStudyPrograms = function (studyProgramA, studyProgramB) {
        return studyProgramA.courseTitle.localeCompare(studyProgramB.courseTitle);
    };
    return GroupDetailController;
}());
exports.GroupDetailController = GroupDetailController;



/** WEBPACK FOOTER **
 ** ./app/group-detail/group-detail.controller.ts
 **/